<div class="custom-field mb-5">
  <mat-card class="lum-mat-card">
    <mat-card-content>
      <div class="p-5">
        <div class="d-flex justify-content-between">
          <div class="align-self-center">
            <h5 class="mt-4 inline"
              >Toggle Inventory Numbers for Warehouse Groups</h5
            >
          </div>
        </div>
        <mat-divider class="my-2"></mat-divider>
      </div>
      <div class="p-5">
        <ng-container *ngIf="loading === false">
          <lum-setting-warehouse-group-inventory-numbers-table
            *ngIf="data?.length; else empty"
            (toggleEvent)="onToggleEvent($event)"
            [data]="data"
          ></lum-setting-warehouse-group-inventory-numbers-table>
          <mat-paginator
            [length]="pagination.total || 0"
            [pageSize]="pagination.per_page || paginationConfig.perPage"
            [pageSizeOptions]="paginationConfig.pageSizeOptions"
            [pageIndex]="(pagination.current_page || 1) - 1"
            (page)="onPaginationEvent($event)"
            aria-label="Select page"
          >
          </mat-paginator>
        </ng-container>

        <div
          class="overlay"
          lumAppLoader
          [loading]="loading"
          [classes]="'loading blur'"
        ></div>

        <ng-template #empty>
          <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</div>
